import useTranslateText from "./Translate/translation";
import { useTranslation } from "react-i18next";

const usePlaceholders = () => {
  const { t } = useTranslation();
  const searchHotel = useTranslateText(t("searchHotel"));
  const selectDateRange = useTranslateText(t("selectDateRange"));
  const selectRoomTypes = useTranslateText(t("selectRoomTypes"));
  const selectLocation = useTranslateText(t("selectLocation"));
  const searchTransferLocations = useTranslateText(t("searchTransferLocations"));
  const FlightNo = useTranslateText(t("FlightNo"));
  const selectPickupLocation = useTranslateText(t("selectPickupLocation"));
  const selectDropLocation = useTranslateText(t("selectDropLocation"));
  const selectTime = useTranslateText(t("selectTime"));
  const selectDate = useTranslateText(t("selectDate"));
  const selectAdults = useTranslateText(t("selectAdults"));
  const selectChildren = useTranslateText(t("selectChildren"));
  const selectInfants = useTranslateText(t("selectInfants"));
  const searchExcursion = useTranslateText(t("searchExcursion"));
  const searchTours = useTranslateText(t("searchTours"));
  const selectMonth = useTranslateText(t("selectMonth"));
  const selectSlot = useTranslateText(t("selectSlot"));
  const addGuests = useTranslateText(t("addGuests"));
  const selectYourStay = useTranslateText(t("selectYourStay"));
  const searchPickupLocation = useTranslateText(t("searchPickupLocation"));
  const searchDropLocation = useTranslateText(t("searchDropLocation"));
  const enterYourEmail = useTranslateText(t("enterYourEmail"));
  const selectExcursion = useTranslateText(t("selectExcursion"));
  const otherMethods = useTranslateText(t("otherMethods"));
  const checkInText = useTranslateText(t("checkInText"));
  const checkOutText = useTranslateText(t("checkOutText"));

  return { searchHotel, selectDateRange,selectRoomTypes,
       searchPickupLocation,searchDropLocation, selectLocation,searchTransferLocations,FlightNo,selectPickupLocation,selectDropLocation,selectTime,selectDate,
        selectAdults,selectChildren,selectInfants,searchExcursion,selectExcursion,
        searchTours,selectMonth,selectSlot,addGuests,selectYourStay,enterYourEmail,otherMethods,
        checkInText,checkOutText
    };
};

export default usePlaceholders;